export const NO_CIRCLES = 16;
export const NO_PLAYER = 0;
export const Player_1 = 1;
export const Player_2 = 2;

export const GAME_STATE_IDLE = 0;
export const GAME_STATE_PLAYING = 1;
export const GAME_STATE_WIN = 2;
export const GAME_STATE_DRAW = 3;